import React from 'react'

import { FormattedMessage } from 'react-intl'

import BidDialog from 'app/components/dialogs/BidDialog'
import useVerifyAuth from 'app/features/ListingFeature/hooks/useVerifyAuth'
import useModal from 'app/hooks/useModal'

import Button, { ButtonProps } from '../base/Button'

interface BidButtonProps {
  auctionId: number
  currency: string
  disabled?: boolean
  onSuccess?: () => void
  onError?: () => void
  sx?: ButtonProps['sx']
  size?: ButtonProps['size']
  text?: string
  exchangeRate?: number
}

const BidButton: RFC<BidButtonProps> = ({
  auctionId,
  currency,
  disabled,
  onSuccess,
  onError,
  sx,
  size = 'large',
  text,
  exchangeRate
}) => {
  const { open, hideModal, showModal } = useModal()

  const checkAuth = useVerifyAuth()

  return (
    <>
      <Button
        onClick={() => {
          checkAuth(showModal)
        }}
        disabled={disabled}
        size={size}
        sx={{
          flex: 1,
          ...sx
        }}
      >
        {text || <FormattedMessage defaultMessage="Place a Bid" />}
      </Button>

      {open && (
        <BidDialog
          open={open}
          onClose={hideModal}
          auctionId={auctionId}
          currency={currency}
          exchangeRate={exchangeRate}
          onSuccess={onSuccess}
          onError={onError}
        />
      )}
    </>
  )
}

export default BidButton
